﻿import React, { useState, useEffect } from 'react';

import { HtmlOutput } from './HtmlOutput'

export const SwitchWithLabel = (props) => {
  const wrappingClass = `single-step__section single-step__section--switch`;
  const isValueObject = typeof props.value === 'object' && props.value !== null;
  const error = (isValueObject && props.value && props.value.error) || props.error;
  const [isChecked, setIsChecked] = useState(isValueObject ? props.value.selected : props.value);

  const onChangeHandler = () => {
    setIsChecked(!isChecked);

    if (isValueObject)
      props.setValue({ ...props.value, selected: !props.value.selected });
    else
      props.setValue(!props.value);
  };

  useEffect(() => setIsChecked(isValueObject ? props.value.selected : props.value), [props.value])

  return (
    <div className={wrappingClass}>
      <label className="single-step__section__switch-wrapper">
        <input className="single-step__section__switch-original" disabled={props.disabled} type="checkbox" aria-invalid={error ? true : null} checked={isChecked} onChange={onChangeHandler} />
        <span className="single-step__section__switch-check" />
        <span className="single-step__section__switch-label">{<HtmlOutput html={props.text} />}
        {error && <span className="validation-error">{error}</span>}</span>
      </label>
    </div>
  );
}